import { render, staticRenderFns } from "./portofolioComponent.vue?vue&type=template&id=3f85fd59&"
import script from "./portofolioComponent.vue?vue&type=script&lang=js&"
export * from "./portofolioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports